<section class="section-gap">
  <div class="d-flex align-items-center justify-content-center">
    <app-badges [badges]="config.badges"></app-badges>
  </div>
  <div #division>
    <kla-title *ngIf="loadDynamicHtml" [lineConfig]="dynamicLineConfig" [config]="dynamicTitleConfig">
      <ng-content></ng-content>
    </kla-title>
    <div *ngIf="!config.iframeStatus">
      <div *ngFor="let htmlItem of html" [innerHTML]="htmlItem.html | safeHtml"></div>
      <div *ngFor="let stylesItem of styles" [innerHTML]="stylesItem | safeHtml"></div>
    </div>
    <iframe (load)="onLoad(iframe)" *ngIf="iframeDisplay && config.iframeStatus" [style.height.px]="iframeHeight"
            #iframe></iframe>
  </div>
</section>

